












import Select from "@/components/Common/Select/Select.vue";
import { defineProps, withDefaults, defineEmits } from "@vue/runtime-dom";
import { computed, onUnmounted, unref } from "@vue/composition-api";
import { useEmailConfirmedList } from "@/stores/admin/lists/emailConfirmedListStore";
import { storeToRefs } from "pinia";
interface Props {
  value: boolean | null;
}
const __sfc_main = {};
__sfc_main.props = {
  value: {
    key: "value",
    required: false,
    type: [Boolean, null],
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const store = useEmailConfirmedList();
  const {
    data
  } = storeToRefs(store);

  // TODO: Переписать ан defineModel в vue 3
  const isEmailConfirmed = computed({
    get: () => props.value,
    set: value => emit("input", value)
  });
  function getEmailConfirmed() {
    store.GET_EMAIL_CONFIRMED();
    return unref(data);
  }
  onUnmounted(() => {
    store.$reset();
  });
  return {
    isEmailConfirmed,
    getEmailConfirmed
  };
};
__sfc_main.components = Object.assign({
  Select
}, __sfc_main.components);
export default __sfc_main;
